import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle, DollarSign, TrendingUp, Shield, Users, Calculator } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: <DollarSign className="h-8 w-8 text-slate-600" />,
      title: "Financial Planning",
      description: "Personalized financial planning designed around your unique goals, timeline, and circumstances.",
      features: ["Retirement Planning", "Estate Planning Coordination*", "Income Distribution Strategies"]
    },
    {
      icon: <TrendingUp className="h-8 w-8 text-slate-600" />,
      title: "Investment Management",
      description: "Professional portfolio management focused on long-term objectives and appropriate risk management.",
      features: ["Portfolio Analysis", "Asset Allocation", "Risk Assessment"]
    },
    {
      icon: <Shield className="h-8 w-8 text-slate-600" />,
      title: "Insurance Solutions",
      description: "Explore insurance coverage options that may help address your family's protection needs.**",
      features: ["Life Insurance", "Disability Insurance", "Long-term Care"]
    },
    {
      icon: <Users className="h-8 w-8 text-slate-600" />,
      title: "Business Services",
      description: "Financial services tailored for business owners and entrepreneurs seeking guidance.",
      features: ["Business Planning", "Employee Benefits", "Succession Planning"]
    },
    {
      icon: <Calculator className="h-8 w-8 text-slate-600" />,
      title: "Tax-Aware Planning",
      description: "Tax-aware planning strategies that aim to help manage your tax obligations in retirement.*",
      features: ["Tax-Efficient Strategies", "Roth Conversion Analysis", "Year-End Planning"]
    }
  ];

  return (
    <section id="services" className="py-16 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
            Our Services
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Financial planning and advisory services designed to help you work toward your long-term goals.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow duration-300 border-slate-200">
              <CardHeader>
                <div className="mb-4">{service.icon}</div>
                <CardTitle className="text-xl text-slate-800">{service.title}</CardTitle>
                <CardDescription className="text-slate-600">
                  {service.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-slate-700">
                      <CheckCircle className="h-4 w-4 text-slate-500 mr-2 flex-shrink-0" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Services Disclaimers */}
        <div className="mt-8 text-xs text-slate-500 max-w-4xl mx-auto space-y-1">
          <p>*Bridgeriver Advisors does not provide tax or legal advice. Clients should consult with their own tax and legal professionals regarding their specific situation.</p>
          <p>**Insurance products and services are offered through Panic Proof Retirement, a separate entity from Bridgeriver Advisors. Insurance guarantees are backed by the financial strength and claims-paying ability of the issuing company.</p>
          <p>Investing involves risk, including the potential loss of principal. No investment strategy can guarantee a profit or protect against loss.</p>
        </div>
      </div>
    </section>
  );
};

export default Services;
